import type { DatePickerPassThroughOptions } from 'primevue';

export const TRANSLATION_GROUP_DATEPICKER = Symbol('datepicker');
export const TRANSLATION_GROUP_DROPDOWN = Symbol('dropdown');
export const TRANSLATION_GROUP_FILE_UPLOAD = Symbol('file.upload');
export const TRANSLATION_GROUP_MULTI_SELECT = Symbol('multi.select');
export const TRANSLATION_GROUP_FORMS_COMMON = Symbol('forms');

export const FORM_INPUT_DEBOUNCE_DEFAULT_MS = 500;

export const FORM_DATE_INPUT_PT_BORDER_FIX: DatePickerPassThroughOptions = {
  dropdown: {
    class: '!border-x-0 !border-t-0',
  },
};
